export const globalStylesDataKey = Symbol( 'globalStylesDataKey' );
export const globalStylesLinksDataKey = Symbol( 'globalStylesLinks' );
export const selectBlockPatternsKey = Symbol( 'selectBlockPatternsKey' );
export const reusableBlocksSelectKey = Symbol( 'reusableBlocksSelect' );
export const sectionRootClientIdKey = Symbol( 'sectionRootClientIdKey' );
export const mediaEditKey = Symbol( 'mediaEditKey' );
export const getMediaSelectKey = Symbol( 'getMediaSelect' );
export const essentialFormatKey = Symbol( 'essentialFormat' );
export const isIsolatedEditorKey = Symbol( 'isIsolatedEditor' );
